import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Emits a toast message event using a global emitter.
 * @param {string} message - The message to be displayed in the toast.
 * @param {Object|null} action - Optional callback function or object to execute.
 * @param {string} variant - Optional variant ('default' or 'danger').
 * @param {string} position - Optional position ('center' or 'right').
 */
export const useAlert = (
  message,
  action = null,
  variant = 'default',
  position = 'center'
) => {
  emitter.emit('newToastMessage', { message, action, variant, position });
};
